import styled from 'styled-components';

export const Container = styled.div`
  .textFieldBaseClassName {
    color-scheme: light;
  }
`;

export const LoaderWrapper = styled.div`
  min-width: 30px;
`;
